"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIPFSLink = void 0;
const config_1 = require("@app/config");
const getIPFSLink = (cid) => `${config_1.CONFIG.ipfsServer}/${cid}`;
exports.getIPFSLink = getIPFSLink;
